module.exports = __webpack_public_path__ + "static/media/mailchimp.854d54e2.png";